import { apiRequest, createUrlWithCenterId } from '../utils/apiHelpers';

export const TipoDeContacto = {
  Email: 1,
  LlamadaTelefonica: 2,
  EncuentroPersonal: 3,
  VisitaTecnica: 4,
  FinalizacionVisitaTecnica: 5,
} as const;

export type TipoDeContactoValue = (typeof TipoDeContacto)[keyof typeof TipoDeContacto];

export const TIPO_CONTACTO_OPTIONS: { id: TipoDeContactoValue; nombre: string }[] = [
  { id: TipoDeContacto.Email, nombre: 'Email' },
  { id: TipoDeContacto.LlamadaTelefonica, nombre: 'Llamada Telefónica' },
  { id: TipoDeContacto.EncuentroPersonal, nombre: 'Encuentro Personal' },
  { id: TipoDeContacto.VisitaTecnica, nombre: 'Visita Técnica' },
  { id: TipoDeContacto.FinalizacionVisitaTecnica, nombre: 'Finalización Visita Técnica' },
];

export interface Contacto {
  id: number;
  tipoDeContacto: number;
  tipoDeContactoNombre?: string;
  fecha: string;
  detalles?: string | null;
  estadoVisitaTecnica?: number | null;
  sucursalId: number;
  sucursalNombre?: string;
  clienteId: number;
  clienteNombre?: string;
  usuarioId: number;
  usuarioNombre?: string;
  activo: boolean;
}

export interface ContactoCreateRequest {
  tipoDeContacto: number;
  fecha: string;
  detalles?: string;
  sucursalId: number;
  usuarioId?: number | null;
}

export interface ContactoUpdateRequest {
  id: number;
  tipoDeContacto: number;
  fecha: string;
  detalles?: string;
  sucursalId: number;
  usuarioId: number;
  activo: boolean;
}

export interface AgendaVentasEvento {
  contactoId: number;
  tipoDeContacto: number;
  tipoDeContactoNombre?: string;
  detalles?: string | null;
  clienteId: number;
  cliente?: string;
  sucursalId: number;
  sucursal?: string;
  usuarioId: number;
  usuario?: string;
  fecha: string;
  start?: string;
  end?: string;
  color?: string;
  title?: string;
  editable?: boolean;
}

export const contactoService = {
  async getAll(params?: {
    clienteId?: number | null;
    sucursalId?: number | null;
    fechaDesde?: string | null;
    fechaHasta?: string | null;
  }): Promise<Contacto[]> {
    const endpoint = createUrlWithCenterId('/api/Contactos', {
      ...(params?.clienteId ? { clienteId: params.clienteId } : {}),
      ...(params?.sucursalId ? { sucursalId: params.sucursalId } : {}),
      ...(params?.fechaDesde ? { fechaDesde: params.fechaDesde } : {}),
      ...(params?.fechaHasta ? { fechaHasta: params.fechaHasta } : {}),
    });
    return apiRequest(endpoint);
  },

  async getById(id: number): Promise<Contacto> {
    return apiRequest(createUrlWithCenterId(`/api/Contactos/${id}`));
  },

  async create(body: ContactoCreateRequest): Promise<Contacto> {
    return apiRequest(createUrlWithCenterId('/api/Contactos'), {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

  async update(id: number, body: ContactoUpdateRequest): Promise<Contacto> {
    return apiRequest(createUrlWithCenterId(`/api/Contactos/${id}`), {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  },

  async remove(id: number): Promise<void> {
    await apiRequest(createUrlWithCenterId(`/api/Contactos/${id}`), {
      method: 'DELETE',
    });
  },

  async getAgendaEvents(params: {
    start: string;
    end: string;
    usuarioId?: number | null;
    clienteId?: number | null;
    sucursalId?: number | null;
  }): Promise<AgendaVentasEvento[]> {
    const endpoint = createUrlWithCenterId('/api/AgendaVentas', {
      start: params.start,
      end: params.end,
      ...(params.usuarioId ? { usuarioId: params.usuarioId } : {}),
      ...(params.clienteId ? { clienteId: params.clienteId } : {}),
      ...(params.sucursalId ? { sucursalId: params.sucursalId } : {}),
    });
    return apiRequest(endpoint);
  },
};
